<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-id-card', fontSet: 'fad'}"
	[headerText]="data?.userData?.firstname + ' ' + data?.userData?.lastname"
	[matDialogData]="data"
	[rect]="rect"
	*ngVar="data?.userData as user"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<div class="userInformation">
			@if (data?.userData) {
				<ng-container>
					<div class="usernameField infoField">
						<div class="descriptive">
							<div class="descriptiveIcon">
								<i class="fad fa-signature"></i>
							</div>
							<div class="descriptiveText">{{ T.USER_CARD_USERNAME_LABEL | translate }}</div>
						</div>
						<div class="value">
							{{ user?.username }}
						</div>
					</div>
					@if (user?.email) {
						<div class="emailField infoField">
							<div class="descriptive">
								<div class="descriptiveIcon">
									<i class="fad fa-envelope"></i>
								</div>
								<div class="descriptiveText">{{ T.USER_CARD_DIALOG_EMAIL_LABEL | translate }}</div>
							</div>
							<div class="value">
								{{ user?.email }}
							</div>
						</div>
					}
					@if (user?.birthday) {
						<div class="birthDate infoField">
							<div class="descriptive">
								<div class="descriptiveIcon">
									<i class="fad fa-birthday-cake"></i>
								</div>
								<div class="descriptiveText">{{ T.USER_CARD_DIALOG_BIRTH_DATE_LABEL | translate }}</div>
							</div>
							<div class="value">
								{{ user?.birthday }}
							</div>
						</div>
					}
					<div class="roles infoField">
						<div class="descriptive">
							<div class="descriptiveIcon">
								<i class="fad fa-user-tag"></i>
							</div>
							<div class="descriptiveText">{{ T.USER_CARD_DIALOG_ROLES_LABEL | translate }}</div>
						</div>
						<div class="value">
							@for (roleName of getRoleNames(user?.roleIds); track roleName; let last = $last) {
								{{ roleName }}
								@if (!last) {
									,
								}
							}
						</div>
					</div>
					@if (user.id === userService.user.id) {
						<div class="calendarAccessTokens infoField">
							<div class="descriptive">
								<div class="descriptiveIcon">
									<i class="fad fa-calendar-day"></i>
								</div>
								<div class="descriptiveText">{{ T.USER_CARD_TOKENS_LABEL | translate }}</div>
							</div>
							<div class="tokenList">
								@for (token of calendarAccessTokens; track token; let last = $last) {
									<div class="token">
										<span class="value">{{ token.id }}</span>
										<button
											(click)="copyToClipboard(token)"
											[@zoomInOnEnter]
											[@zoomOutOnLeave]
											[matTooltipClass]="'accent'"
											[matTooltip]="T.USER_CARD_COPY_CALENDAR_ACCESS_TOOLTIP | translate"
											color="accent"
											mat-icon-button
										>
											<mat-icon fontIcon="fa-clipboard" fontSet="fad" />
										</button>
										<button
											(click)="deleteCalendarAccessToken(token)"
											[@zoomInOnEnter]
											[@zoomOutOnLeave]
											[matTooltipClass]="'warn'"
											[matTooltip]="T.USER_CARD_DELETE_CALENDAR_ACCESS_TOOLTIP | translate"
											color="warn"
											mat-icon-button
										>
											<mat-icon fontIcon="fa-trash-alt" fontSet="fad" />
										</button>
									</div>
								}
								<button
									(click)="createNewCalendarAccessToken()"
									[@zoomInOnEnter]
									appStopPropagation
									class="createButton"
									color="accent"
									mat-button
								>
									<i class="fas fa-plus" style="margin-right: 4px"></i
									>{{ T.USER_CARD_CREATE_CALENDAR_ACCESS_TOOLTIP | translate }}
								</button>
							</div>
						</div>
					}
				</ng-container>
			}
		</div>
	</ng-container>

	<ng-container actions>
		@if (permissionToChangeOwnPassword && user.loginType === LoginType.Local) {
			<button class="changePwdBtn" mat-button color="accent" (click)="changePassword(user)">
				{{ T.USER_CHANGE_PASSWORD | translate }}
			</button>
		}

		<sim-button (onClick)="close()" [icon]="{fontSet: 'fal', fontIcon: 'fa-times'}" [label]="T.BUTTON_CLOSE" color="accent" />
	</ng-container>
</sim-basic-material-dialog>
